import type { ILinkedCard, ILinkedCardDto } from "./ILinkedCard";

export class LinkedCard implements ILinkedCard
{

    linkedCardId: string;
    description: string;
    cardMasked: string;
    cardNickName?: string;
    issuer: string;
    isDefault: boolean;
    expiry: string;
    provider: string;
    providerId: number;
    hasExpired: boolean;
    isExpiring: boolean;
    
    constructor( model: ILinkedCardDto )
    {
        this.linkedCardId = model.linkedCardId;
        this.description = model.description;
        this.cardNickName = model.cardNickName;
        this.cardMasked = this.normaliseMaskedCard( model.cardMasked );
        this.issuer = model.issuer;
        this.isDefault = model.isDefault;
        this.expiry = model.expiry;
        this.provider = model.provider;
        this.providerId = model.providerId;
        this.hasExpired = model.hasExpired;
        this.isExpiring = model.isExpiring;
    }

    /**
     * Normalises the masked card to just the digits
     * @param cardMasked 
     * @returns 
     */
    private normaliseMaskedCard( cardMasked: string )
    {
        return ( cardMasked ?? '' ).replace( /[^\d]+/g, '' );
    }

}